class FaxGenericPDFComposite {
    public patientId: string;
    public pdfFileName: string;
    public doctorName: string;
    public doctorIdentifier: string;
    public doctorAddress: string;
    public doctorPhone: string;
    public doctorFax: string;
    public sentFaxItemTypeId: number;
    public SentFaxItemId: string;
}

export { FaxGenericPDFComposite };
